module.exports = __webpack_public_path__ + "img/AM.3f177416.svg";